export interface ISwapStatus {
    isChainBroken: boolean,
    isChainEnded: boolean,
    isInOffers: boolean,
    isInCrossMatching: boolean,
    isInPending: boolean,
    isInLogistics: boolean,
    isInProcess: boolean
}